import { Box, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay } from "@chakra-ui/react";
import {
  call,
  ColorIcon,
  colors,
  customEvent,
  getCdnImageSrc,
  HStack,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";

export default function UrgentModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const router = useRouter();
  return (
    <Box height="100%" width="100%">
      <Modal
        isOpen={isOpen}
        onClose={() => {
          customEvent({
            newGtm: {
              path: "snackbar",
              trigger_and_target: "urgent_mdl-close",
            },
            triggerHackle: true,
          });
          onClose();
        }}
        closeOnOverlayClick={false}
        scrollBehavior="inside"
        isCentered={true}
        useInert={false}
      >
        <ModalOverlay width="100%" height="100%" />
        <ModalContent
          minWidth="300px"
          backgroundColor={colors.gray700}
          backgroundImage={getCdnImageSrc("platform/home/modal-background.png")}
          backgroundSize="cover"
        >
          <ModalBody padding="20px 24px 44px">
            <VStack width="100%" gap={10}>
              <HStack width="100%" justifyContent="end">
                <div
                  onClick={() => {
                    customEvent({
                      newGtm: {
                        path: "snackbar",
                        trigger_and_target: "urgent_mdl-close",
                      },
                      triggerHackle: true,
                    });
                    onClose();
                  }}
                >
                  <ColorIcon name="close" width={24} height={24} color={colors.white} />
                </div>
              </HStack>
              <VStack width="100%" gap={24}>
                <HStack width="100%" alignItems="center" gap={8}>
                  <ColorIcon name="icon-call-mono" color={colors.white} width={16} height={16} />
                  <div className="subtitle_21_b white">24시간 임종 상담</div>
                </HStack>
                <VStack gap={12} width="100%" className="body_16_m gray100">
                  <div>
                    경황 없는 임종 전후
                    <br />
                    부담없이 연락주세요.
                  </div>
                  <div>
                    염두에 두고 있는 장례식장,
                    <br />
                    장례서비스가 없으시더라도
                  </div>
                  <div>준비가 되지 않으셨다 하더라도</div>
                  <div>24시간 언제든지, 대기하고 있습니다.</div>
                  <div>
                    진정성있는, 검증된 장례지도사가
                    <br />
                    지금 이 순간부터
                    <br />
                    상주님을 도와드리겠습니다.
                  </div>
                </VStack>
              </VStack>
            </VStack>
          </ModalBody>
          <ModalFooter padding={0}>
            <HStack width="100%">
              <LargeButton
                height={60}
                borderRadius="0 0 0 5px"
                buttonType={LARGEL_BUTTON_TYPE.GRAY900}
                className="button_16_sb white"
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "snackbar",
                      trigger_and_target: "urgent_mdl_ftr_lft-uv_review",
                    },
                    triggerHackle: true,
                  });
                  router.push("/review");
                }}
              >
                후기 확인
              </LargeButton>

              <LargeButton
                height={60}
                borderRadius="0 0 5px 0"
                buttonType={LARGEL_BUTTON_TYPE.ORANGE}
                className="button_16_sb white"
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "snackbar",
                      trigger_and_target: "urgent_mdl_ftr_rght-actn_call",
                    },
                    triggerHackle: true,
                  });
                  call("1666-9784", true);
                }}
              >
                <HStack width="100%" alignItems="center" justifyContent="center" gap={8}>
                  <ColorIcon name="icon-call-mono" color={colors.white} width={16} height={16} />
                  <div>24시간 상담</div>
                </HStack>
              </LargeButton>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
